export type TRegister = {
    from: string, to: string
}

export enum MeterType {
    SIMPLE = 'simple',
    COMPOUND = 'compound'
}

export type TimeSignatureType =  `${number}-${number}`